module.exports = "/images/logo.png?87e8d1617b9a88746d124b935a9d8852";